import React, { ReactNode, useState } from "react";
import { isMobile } from "react-device-detect";
import caseRelatedActionsStyle from "./caseRelatedActionsStyle";
import { Drawer, Fab, Grid, Paper, Stack } from "@mui/material";
import { Add, AddOutlined, RemoveOutlined } from "@mui/icons-material";
import { Transition } from "react-transition-group";
import ActionButton, { ActionButtonProps } from "../../Actions/ActionButton";
import { Roles } from "../../../types/BackofficeUser";
import { userHasOneOfTheseRoles } from "../../../services/backofficeUserService";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";

type CaseRelatedContainerProps = {
  mainActions: ReactNode;
  moreActions: ReactNode;
  setUseCondensedView: Function;
} & Pick<ActionButtonProps, "useCondensedView">;
const CaseRelatedContainer = ({
  mainActions,
  moreActions,
  useCondensedView,
  setUseCondensedView,
}: CaseRelatedContainerProps) => {
  const currentUser = useCurrentUser();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const nodeRef = React.useRef<HTMLDivElement|null>(null)

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  if (isMobile) {
    return (
      <>
        <Fab sx={caseRelatedActionsStyle.fab} onClick={() => setIsDrawerOpen(true)}>
          <Add />
        </Fab>
        <Drawer open={isDrawerOpen} anchor={"bottom"} onClose={() => setIsDrawerOpen(false)}>
          <Grid container sx={caseRelatedActionsStyle.drawer}>
            {mainActions}
            {!userHasOneOfTheseRoles(currentUser, [Roles.external, Roles.callcenter]) && (
              <>
                {showMore && moreActions}
                <ActionButton
                  text={showMore ? "Weniger" : "Mehr"}
                  onClick={toggleShowMore}
                  icon={showMore ? RemoveOutlined : AddOutlined}
                />
              </>
            )}
          </Grid>
        </Drawer>
      </>
    );
  } else {
    return (
      <Transition nodeRef={nodeRef} in={showMore} timeout={500}>
        {(state) => (
          <Grid
            container
            ref={(el) => {
              if (el) {
                setUseCondensedView(el.getBoundingClientRect().height < 800);
                nodeRef.current = el;
              }
            }}
            component={Paper}
            sx={[
              caseRelatedActionsStyle.actionsContainer,
              caseRelatedActionsStyle[`${state}Transition` as keyof typeof caseRelatedActionsStyle],
            ]}
          >
            <Grid size={6}>
              <Stack sx={{
                alignItems: "center"
              }}>
                {mainActions}
                {!userHasOneOfTheseRoles(currentUser, [Roles.external, Roles.callcenter]) && (
                  <ActionButton
                    text={showMore ? "Weniger" : "Mehr"}
                    onClick={toggleShowMore}
                    icon={showMore ? RemoveOutlined : AddOutlined}
                    useCondensedView={useCondensedView}
                  />
                )}
              </Stack>
            </Grid>
            <Grid size={6}>
              {!userHasOneOfTheseRoles(currentUser, [Roles.external, Roles.callcenter]) && (
                <Stack sx={{
                  alignItems: "center"
                }}>
                  {moreActions}
                </Stack>
              )}
            </Grid>
          </Grid>
        )}
      </Transition>
    );
  }
};
export default CaseRelatedContainer;
